// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { get, flatMap } from 'lodash/fp';

// Styles
import './DrawingEditorPathPointsDebugger.scss';

const DrawingEditorPathPointsDebugger = (props) => {
    const { paths } = props;

    const points = flatMap(get('points'), paths);

    return (
        <div className="DrawingEditorPathPointsDebugger">
            {points.map((point, index) => (
                <div key={index} className="point" style={{ left: point[0], top: point[1] }} />
            ))}
        </div>
    );
};

DrawingEditorPathPointsDebugger.propTypes = {
    paths: PropTypes.array,
};

export default DrawingEditorPathPointsDebugger;
